var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconListQuill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 23.26h-6a1.5 1.5 0 0 1-1.5-1.5V2.26a1.5 1.5 0 0 1 1.5-1.5h10.63a1.5 1.5 0 0 1 1.06.44l5.87 5.87a1.54 1.54 0 0 1 .44 1.19",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75.76v6a1.5 1.5 0 0 0 1.5 1.5h6M8.17 9.62 6 12.46a.78.78 0 0 1-.55.3.77.77 0 0 1-.58-.22l-1.12-1.16m4.42 4.99L6 19.21a.78.78 0 0 1-.55.3.77.77 0 0 1-.58-.22l-1.12-1.16m7.23 5.13 5.83-5.84m6.37-6.36a10.48 10.48 0 0 0-2.24 0l-2 3.18L17.71 12c-4.46 2.19-6.21 7.48-4.55 9.13 2.21 2.17 10.97-1.71 10.02-10.07Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconListQuill);
export default __webpack_public_path__ + "static/media/streamline-icon-list-quill.24c994e7.svg";
export { ForwardRef as ReactComponent };